<template>
  <div class="login-page">
    <!-- 简洁头部 -->
    <header class="header">
      <h1 class="title">核对信息数据发布平台</h1>
      <p class="subtitle">核对补填数据 · 保护个人隐私 · 操作简单易用</p>
    </header>

    <!-- 主内容 -->
    <main class="main-content">
      <!-- 左侧展示图 -->
      <div class="showcase-section">
        <img src="/checking/hompage_images/p1.jpg" alt="平台展示" class="showcase-image"/>
      </div>

      <!-- 右侧登录 -->
      <div class="login-section">
        <div class="login-card">
          <h2 class="card-title">扫码登录</h2>
          <p class="card-desc">使用核对信息小程序扫码，安全便捷</p>

          <button class="login-btn" @click="scanLogin">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 3h6v6H3zM15 3h6v6h-6zM3 15h6v6H3zM15 15h6v6h-6z"/>
            </svg>
            打开登录二维码
          </button>

          <div class="steps">
            <div class="step">
              <span class="step-num">1</span>
              <span>点击上方按钮，弹出方形二维码窗口</span>
            </div>
            <div class="step">
              <span class="step-num">2</span>
              <span>打开<strong>核对信息小程序</strong>扫码登录</span>
            </div>
          </div>

          <button class="help-link" @click="howToSwitch">
            扫码失败？切换浏览器模式
          </button>
        </div>
      </div>
    </main>

    <!-- 底部版权 -->
    <footer class="footer">
      <span>智韬科技</span>
      <span>|</span>
      <a href="https://beian.miit.gov.cn" target="_blank">陇ICP备19004729号-8</a>
      <span>|</span>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62010202004356" target="_blank">
        <img src="http://www.hedui.top/checking/images/gongan_beian_logo.png" alt="公安备案"/>
        甘公网安备62010202004356号
      </a>
    </footer>

    <!-- 模式切换帮助弹窗 -->
    <el-dialog
      width="700px"
      :close-on-click-modal="false"
      title="如何切换浏览器的模式"
      :visible.sync="browserSwitchDialogVisible"
      custom-class="browser-dialog">
      <div class="help-box">
        <p>如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"</p>
        <div class="help-images">
          <img src="../assets/switch_browser.png" alt="切换浏览器模式"/>
          <img src="../assets/good_browser.png" alt="正确模式"/>
        </div>
      </div>
      <div slot="footer">
        <button class="btn-primary" @click="browserSwitchDialogVisible=false">我知道了</button>
      </div>
    </el-dialog>

    <!-- 扫码登录弹窗 -->
    <el-dialog
      width="750px"
      :close-on-click-modal="false"
      title="用核对信息小程序扫码登录"
      :visible.sync="scanLoginDialogVisible"
      :before-close="beforeClose"
      custom-class="scan-dialog">
      <div class="scan-box">
        <div class="qr-item">
          <p>第一步：打开小程序</p>
          <img src="/checking/images/checking_qrcode.jpg" alt="小程序码"/>
        </div>
        <div class="qr-guide">
          <p>用<span class="blue">核对信息微信小程序</span>"更多功能"中的"扫码登录电脑端"扫右侧二维码登录</p>
          <p style="color:red;font-weight: bold;">
            <i class="el-icon-warning"></i>
            如果扫码后无法登录：1.检查浏览器是否是“高速模式”；2.更换浏览器或清空浏览器缓存(清空浏览记录)。
          </p>
          <button class="btn-text" @click="howToSwitch">如何切换浏览器模式</button>
        </div>
        <div class="qr-item">
          <p>第二步：扫码登录</p>
          <img :src="login_qrcode_url" alt="登录二维码"/>
        </div>
      </div>
      <div slot="footer">
        <button class="btn-default" @click="closeScan">关闭</button>
      </div>
    </el-dialog>

    <!-- 测试登录弹窗 -->
    <el-dialog
      width="400px"
      :close-on-click-modal="false"
      title="测试登录"
      :visible.sync="testDialogVisible"
      :before-close="beforeClose"
      custom-class="test-dialog">
      <el-form :model="loginForm" status-icon ref="loginForm" label-width="80px">
        <el-form-item label="手机号" prop="username">
          <el-input type="text" v-model="loginForm.username" autocomplete="off" placeholder="输入手机号">
            <i slot="prefix" class="el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')"
            autocomplete="off" placeholder="输入密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <button class="btn-primary" @click="submitForm('loginForm')">登录</button>
        <button class="btn-default" @click="cancelTestLogin">取消</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      browserSwitchDialogVisible: false,
      loginForm: {
        username: '',
        password: '',
        qrcode_url: '/checking/web/_qrcode.jsp'
      },
      scanLoginDialogVisible: false,
      timer: null,
      scanDownloadDialogVisible: false,
      showDownloadLink: false,
      download_file_url: '',
      login_qrcode_url: '/checking/web/_qrcode.jsp',
      download_qrcode_url: '/checking/web/_download_qrcode.jsp',
      testDialogVisible: false
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  created() {
    this.$session.set('USERNAME', '')
    this.$session.set('NAME', '')
  },
  methods: {
    submitForm(formName) {
      let that = this
      if (this.loginForm.username === '') {
        that.$message.error('请输入手机号')
        return
      }
      if (this.loginForm.password === '') {
        that.$message.error('请输入密码')
        return
      }
      const load = this.$loading({
        lock: true,
        text: '登录中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var requestUrl = '/checking/web/_login.jsp'
      this.axios.get(requestUrl, {
        params: {
          username: that.loginForm.username,
          password: that.loginForm.password
        }
      }).then(function(response) {
        var result = response.data.result
        if (result === '0') {
          that.$session.set('USERNAME', that.loginForm.username)
          that.$session.set('NAME', response.data.name)
          that.$router.push({
            path: '/query_list',
            params: {
              username: that.loginForm.username
            }
          })
        } else {
          var tip = response.data.password_tip
          if (tip === '') {
            that.$message.error('账号错误,登录失败！')
          } else {
            that.$message.error('密码错误,登录失败！密码提示:' + tip)
          }
        }
        load.close()
      }).catch(err => {
        that.$message.error('登录失败，网络异常请稍后重试！')
        console.log(err)
        load.close()
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    registe() {
      this.$router.push('/registe')
    },
    howToSwitch() {
      this.browserSwitchDialogVisible = true
    },
    enterFun() {},
    forgotPassword() {
      this.$message.error('请用手机端多人填表小程序查看密码!')
    },
    scanLogin() {
      let that = this
      var timestamp = new Date().getTime()
      this.login_qrcode_url = this.login_qrcode_url + '?t=' + timestamp
      this.timer = setInterval(function() {
        var requestUrl = '/checking/web/_query_login_state.jsp'
        that.axios.get(requestUrl, {
          params: {}
        }).then(function(res) {
          var usr = res.data.username
          if (res.data.result === '1') {
            that.$session.set('USERNAME', usr)
            clearInterval(that.timer)
            that.$router.push({
              path: '/query_list',
              params: {
                username: usr
              }
            })
          }
        })
      }, 1000)
      this.scanLoginDialogVisible = true
    },
    closeScan() {
      clearInterval(this.timer)
      this.scanLoginDialogVisible = false
    },
    beforeClose() {
      this.closeScan()
    },
    scanDownload() {
      let that = this
      var timestamp = new Date().getTime()
      this.download_qrcode_url = this.download_qrcode_url + '?t=' + timestamp
      this.timer = setInterval(function() {
        var requestUrl = '/checking/web/_query_download_state.jsp'
        that.axios.get(requestUrl, {
          params: {}
        }).then(function(res) {
          if (res.data.result === '1') {
            var download_file_url = res.data.download_file_url
            clearInterval(that.timer)
            that.download_file_url = download_file_url
            this.$message.success('文件已经传输成功，请点下载文件按钮下载！')
            console.log(download_file_url)
          }
        })
      }, 1000)
      this.download_file_url = ''
      this.scanDownloadDialogVisible = true
    },
    closeDownload() {
      clearInterval(this.timer)
      this.scanDownloadDialogVisible = false
    },
    downloadFile() {
      window.open(this.download_file_url)
    },
    testLogin() {
      this.testDialogVisible = true
    },
    cancelTestLogin() {
      this.testDialogVisible = false
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.login-page {
  min-height: 80vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 头部 */
.header {
  text-align: center;
  padding: 30px 20px 20px;
  background: #fff;
  border-bottom: 1px solid #e8ecf1;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #1485FB;
  margin: 0 0 8px;
}

.subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 主内容 */
.main-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  padding: 40px 30px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

/* 左侧展示 */
.showcase-section {
  flex: 1;
  max-width: 500px;
}

.showcase-image {
  width: 100%;
  height: 350px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

/* 右侧登录 */
.login-section {
  width: 360px;
}

.login-card {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 6px;
  text-align: center;
}

.card-desc {
  font-size: 13px;
  color: #999;
  margin: 0 0 24px;
  text-align: center;
}

.login-btn {
  width: 100%;
  padding: 12px;
  background: #1485FB;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
  transition: background 0.2s;
}

.login-btn:hover {
  background: #0d7aef;
}

.login-btn svg {
  width: 20px;
  height: 20px;
}

.steps {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #555;
  line-height: 1.6;
}

.step + .step {
  margin-top: 12px;
}

.step-num {
  width: 20px;
  height: 20px;
  background: #1485FB;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.step strong {
  color: #1485FB;
}

.help-link {
  display: block;
  width: 100%;
  text-align: center;
  background: none;
  border: none;
  color: #999;
  font-size: 13px;
  cursor: pointer;
  padding: 8px;
  transition: color 0.2s;
}

.help-link:hover {
  color: #1485FB;
}

/* 底部版权 */
.footer {
  text-align: center;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e8ecf1;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.footer a {
  color: #666;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.footer a:hover {
  color: #1485FB;
}

.footer img {
  width: 16px;
  height: 16px;
}

/* 弹窗样式 */
.browser-dialog >>> .el-dialog__header,
.scan-dialog >>> .el-dialog__header,
.test-dialog >>> .el-dialog__header {
  background: #1485FB;
  padding: 16px 20px;
}

.browser-dialog >>> .el-dialog__title,
.scan-dialog >>> .el-dialog__title,
.test-dialog >>> .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

.browser-dialog >>> .el-dialog__headerbtn .el-dialog__close,
.scan-dialog >>> .el-dialog__headerbtn .el-dialog__close,
.test-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.help-box {
  padding: 10px 0;
}

.help-box p {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.help-images {
  display: flex;
  gap: 20px;
}

.help-images img {
  flex: 1;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.scan-box {
  display: flex;
  gap: 30px;
  padding: 10px 0;
}

.qr-item {
  text-align: center;
  flex: 0 0 160px;
}

.qr-item p {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}

.qr-item img {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

.qr-guide {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.qr-guide p {
  font-size: 14px;
  color: #555;
  line-height: 1.8;
  margin: 0 0 12px;
}

.qr-guide .blue {
  color: #1485FB;
  font-weight: 500;
}

.qr-guide .tip {
  font-size: 12px;
  color: #c62828;
  background: #ffebee;
  padding: 10px 16px;
  border-radius: 6px;
}

.btn-primary {
  padding: 8px 24px;
  background: #1485FB;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  margin-left: 8px;
}

.btn-primary:hover {
  background: #0d7aef;
}

.btn-default {
  padding: 8px 24px;
  background: #f0f0f0;
  border: none;
  border-radius: 6px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
}

.btn-default:hover {
  background: #e0e0e0;
}

.btn-text {
  background: none;
  border: none;
  color: #1485FB;
  font-size: 13px;
  cursor: pointer;
  padding: 6px 12px;
}

.btn-text:hover {
  text-decoration: underline;
}

/* 响应式 */
@media (max-width: 900px) {
  .main-content {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  .showcase-section {
    max-width: 100%;
    width: 100%;
  }

  .showcase-image {
    height: 250px;
  }

  .login-section {
    width: 100%;
    max-width: 400px;
  }

  .scan-box {
    flex-direction: column;
    align-items: center;
  }

  .qr-guide {
    order: -1;
  }

  .help-images {
    flex-direction: column;
  }

  .help-images img {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .footer {
    flex-direction: column;
    gap: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue